var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "FpFlex",
    {
      attrs: {
        "space-around": "",
        compact: "",
        "justify-content": _vm.FlexJustifyContent.spaceBetween,
        "align-items": _vm.FlexAlignItems.center
      }
    },
    [
      _c(
        "FpFlexItem",
        [
          _c(
            "FpImage",
            {
              style: { width: "100px", height: "100%" },
              attrs: { title: _vm.$t("common.images.flatfairLogo.title") }
            },
            [
              _c("img", {
                style: { cursor: "pointer", width: "100%" },
                attrs: {
                  src: _vm.flatfairLogo,
                  alt: _vm.$t("common.images.flatfairLogo.alt")
                },
                on: { click: _vm.goToHome }
              })
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("FpFlexItem", [_vm._t("default")], 2)
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }